import RadioControl from './RadioControl';
import FormControlLabel, { FormControlLabelProps } from '../FormControlLabel';

export interface RadioProps extends Omit<FormControlLabelProps, 'control'> {
  control?: FormControlLabelProps['control'];
}

export default function Radio(props: RadioProps) {
  return <FormControlLabel control={<RadioControl />} {...props} />;
}
